import { Component, OnInit, ElementRef, ViewChild, Output, EventEmitter, Input, ChangeDetectionStrategy } from '@angular/core';
import { TexteService } from 'src/app/core/services/texte.service';
import { faTrash } from '@fortawesome/free-solid-svg-icons';


@Component({
    selector: 'app-upload-file-custom',
    templateUrl: './upload-file-custom.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UploadFileCustomComponent implements OnInit {

    @ViewChild('input', { static: false }) input: ElementRef;
    @Output() fileChange: EventEmitter<File | null> = new EventEmitter<File | null>();
    @Input() internationnal = false;
    @Input({ required: true }) inputId!: string;

    isEmpty: boolean;
    public faTrash = faTrash;

    public file: File | null = null;
    public fileAccept: string;

    get fileName() {
        if (this.file != null) {
            return this.file.name;
        } else {
            return this.texteService.getTexte('LABEL_NO_FILE');
        }
    }

    constructor(
        public texteService: TexteService
    ) { }

    ngOnInit(): void {
        this.isEmpty = false;
        this.fileAccept = '.pdf, .jpeg, .jpg, .png';
        // if (this.internationnal) {
        // } else {
        //     this.fileAccept = '.pdf, .doc, .docx, .xls, .jpeg, .png, .bmp, .gif';            
        // }
    }

    onButtonClick() {
        this.input.nativeElement.click();
        return this.isEmpty = false;
    }

    fileChangeEvent(files: FileList) {
        if (this.isEmpty) {
            this.fileChange.emit(null);
        } else {
            this.file = files.item(0);
            this.fileChange.emit(this.file);

        }
    }

    onButtonSuppClick() {
        this.file = null;
        this.fileChange.emit(this.file);
        return this.isEmpty = true;
    }
}
